// extracted by mini-css-extract-plugin
export default {"link":"BrokerageTable_link__bj55V"};